import { useMutation } from '@tanstack/react-query';
import { inboxFeatureStore } from '../../../features/Inbox/store';
import { apiClient, getEndpoints } from '../../common';
import { NOTIFICATION_CHANGE_REQUEST_NAMESPACE } from './constants';
import { invalidateNotificationListQuery } from './utils';

interface IUseApplyChangeRequestParams {
	id?: string;
}

export function useApplyChangeRequest({ id }: IUseApplyChangeRequestParams) {
	const mutationFn = async () => {
		if (!id) {
			return null;
		}

		const url = `${getEndpoints(NOTIFICATION_CHANGE_REQUEST_NAMESPACE).byId(
			id
		)}apply`;

		const { data } = await apiClient.post(url);
		return data;
	};

	const mutation = useMutation({
		mutationKey: ['applyChangeRequest', id],
		mutationFn,
		onSuccess: () => {
			if (id && !inboxFeatureStore.showRead) {
				inboxFeatureStore.addToRecentlyRead(id);
			}
			invalidateNotificationListQuery();
		},
	});

	return {
		...mutation,
		isApplied: mutation.isSuccess,
	};
}
